import { Divider, Grid, Typography } from "@mui/material"
import React from "react"
import WSTextField from "../../Components/TextBox/WSTextBox"
import { useForm } from "react-hook-form";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";

export const Remark:React.FC<any>=React.memo((props)=>{

    const { register, control } = useForm();

    return(
        <Grid container  padding={2}>
        <Grid item xs={12}>
          <Typography>Set Remark for Receipt</Typography>
          <Divider sx={{ mt: 1, mb: 2 }} /> {/* Divider with spacing around it */}
        </Grid>
  
        
  
        <Grid item xs={12} >
        <WSTextAreaField
                  label={""}
                  id={"description"}
                  name={"description"}
                  control={control}
                  rules={{ required: false }}
                  rows={3}
                />         
        </Grid>
      </Grid>
    )
})